import type { Node } from '@tiptap/pm/model';
import { Extension, isNodeEmpty } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export interface PlaceholderOptions {
  placeholder: string;
  placeholderNodeIndex?: number;
}

export const Placeholder = Extension.create<PlaceholderOptions>({
  name: 'placeholder',

  addOptions() {
    return {
      placeholder: '',
      placeholderNodeIndex: 0
    };
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('placeholder'),
        props: {
          decorations: ({ doc }) => {
            if (!this.editor.isEditable) {
              return null;
            }

            const nodes: Array<[Node, number]> = [];

            doc.forEach((node, pos, index) => {
              if (
                typeof this.options.placeholderNodeIndex !== 'number' ||
                index >= this.options.placeholderNodeIndex
              ) {
                nodes.push([node, pos]);
              }
            });

            if (
              !nodes.length ||
              nodes.some(([node]) => !isNodeEmpty(node, { ignoreWhitespace: true }))
            ) {
              return null;
            }

            const [node, pos] = nodes[0];
            const decoration = Decoration.node(pos, pos + node.nodeSize, {
              'data-placeholder': this.options.placeholder
            });

            return DecorationSet.create(doc, [decoration]);
          }
        }
      })
    ];
  }
});
